import { trackUmamiEvent } from '@jaseeey/vue-umami-plugin';

const approvedProductEvents = new Set([
    'market_overview_opened',
    'market_watch_opened',
    'specialisation_selected',
    'xprt_jobs_handoff',
    'market_watch_created',
    'market_watch_updated',
    'market_watch_deleted',
    'career_profile_opened'
]);

const payloadValidators = Object.freeze({
    component: value => typeof value === 'string' && /^[a-z][a-z0-9_]{0,63}$/.test(value),
    route: value => typeof value === 'string' && /^\/[a-z0-9/-]{0,127}$/.test(value),
    classificationId: value => Number.isSafeInteger(value) && value > 0,
    classificationSlug: value => isRouteSlug(value),
    locationId: value => Number.isSafeInteger(value) && value > 0,
    locationSlug: value => isRouteSlug(value)
});

/**
 * Sends a product event to Umami, dropping anything outside the approved event names and payload shapes so that no
 * identifier or free text reaches the analytics dashboard.
 *
 * @param {string} event - The event name, which must be one of the approved product events.
 * @param {Object} [payload] - Coarse event properties, each of which must pass its own validator.
 * @returns {boolean} - True when the event was sent, false when it was rejected.
 */
export function trackProductEvent(event, payload = {}) {
    if (!approvedProductEvents.has(event) || !isSafePayload(payload)) {
        return false;
    }
    if (Object.keys(payload).length === 0) {
        trackUmamiEvent(event);
    } else {
        trackUmamiEvent(event, payload);
    }
    return true;
}

function isSafePayload(payload) {
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
        return false;
    }
    return Object.entries(payload).every(([key, value]) => payloadValidators[key]?.(value) === true);
}

function isRouteSlug(value) {
    return typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value);
}
